import { links, getBrandLink } from 'common/helpers'


type GetSeoProductsLinkInput = {
  brand?: string
  isMale: boolean
  url: string
}

const getSeoProductsLink = ({ brand = '', isMale, url }: GetSeoProductsLinkInput): string => {
  if (/cream/.test(url) && typeof links.handCreams === 'string') {
    return links.handCreams
  }
  if (/body-lip/.test(url) && typeof links.bodyLip === 'string') {
    return links.bodyLip
  }
  if (/candles/.test(url) && typeof links.candles === 'string') {
    return links.candles
  }
  if (/palette/.test(url) && typeof links.makeupPalettes === 'string') {
    return links.makeupPalettes
  }
  if (/eyeliner/.test(url) && typeof links.makeupEye === 'string') {
    return links.makeupEye
  }
  if (/lip/.test(url) && typeof links.makeupLip === 'string') {
    return links.makeupLip
  }
  if (
    /extras/.test(url)
    && typeof links.subscription !== 'string'
    && typeof links.subscription.extras === 'string'
  ) {
    return links.subscription.extras
  }

  return getBrandLink({ brand, isMale })
}


export default getSeoProductsLink
